import { useState, useEffect } from "react";
import { getInterviewSlotsUrl } from "./utils/scheduleInterview";
import { Navigate } from "react-router-dom";

const ScheduleInterviewSlots = ({ jobseekerId, jobId }) => {
    const [slotUrl, setSlotUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getInterviewSlots = async () => {
            try {
                setLoading(true);
                setError(null);
                const response = await getInterviewSlotsUrl(jobseekerId, jobId);
                // Extract the URL from the response object
                const url = response.url || response;
                setSlotUrl(url);
            } catch (err) {
                setError(err.message || 'Failed to fetch interview slots');
                console.error('Error fetching interview slots:', err);
            } finally {
                setLoading(false);
            }
        };

        if (jobseekerId && jobId) {
            getInterviewSlots();
        } else {
            setLoading(false);
        }
    }, [jobseekerId, jobId]);

    // Redirect when slotUrl is available
    useEffect(() => {
        if (slotUrl) {
            window.location.replace(slotUrl);
        }
    }, [slotUrl]);

    if (!jobseekerId || !jobId) {
        return <div>Jobseeker ID or Job ID is required</div>;
    }

    if (loading) {
        return <div>Loading interview slots...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!slotUrl) {
        return <div>No Slot Url Found</div>;
    }

    // This will be shown briefly before redirect
    return <div>Redirecting to interview slots...</div>;
};

export default ScheduleInterviewSlots;